
import { Component, Prop } from 'vue-property-decorator'
import Swiper, { SwiperOptions } from 'swiper'
import ImageCarousel from './image-carousel.vue'

@Component({})
export default class ImageCarouselForProduct extends ImageCarousel {
  @Prop({default: ''}) sliderName!: string

  swiperTop: Swiper | null = null

  prevButton = ''
  nextButton = ''


  swiperOptionsThumbsProduct: SwiperOptions = {
    slidesPerView: 1,
    freeMode: true,
    speed: 500,
    on: {
      slideChange: this.onSlideChange
    },

    breakpoints: {
      600: {
        spaceBetween: 20,
        slidesPerView: 4
      }
    }
  }


  swiperOptionsTopForProduct: SwiperOptions = {
    grabCursor: true,
    effect: 'fade',
    fadeEffect: { crossFade: true },
    navigation: {
      nextEl: '.top.swiper-next--' + this.sliderName,
      prevEl: '.top.swiper-prev--' + this.sliderName
    },
    speed: 500,
    on: {
      slideChange: this.onSlideChange
    }
  }


  mounted() {
    // init swiper top with thumbs as controls
    if (this.amountOfImages > 1) {
      this.$nextTick(() => {
        const thumbSwiper = (this.$refs.swiperThumbs as any).$swiper as Swiper
        const swiperTop = (this.$refs.swiperTop as any).$swiper as Swiper
        this.swiperTop = swiperTop
        this.thumbSwiper = thumbSwiper

      })
    }
  }

}
